fx.ns("desktop.common.preview", class BookPreview extends fx.Component
{
	constructor(data)
	{
		super(data);

		this._index = 0;
		this._currentElement = null;
	}

	get book()
	{
		return this.data.creation;
	}

	get currentElement(){
        return this._currentElement;
    }

    set currentElement(val)
    {
        if (this._currentElement == val)
        {
            if (this._currentElement)
                this._currentElement.activate(val);
                
            return;
        }
        
        if (this._currentElement)
        {
            this._currentElement.activate( false );
        }
     
        this._currentElement = val;

		this.frameAction.currentArea = this.area;
        this.frameAction.currentElement = val;

        if (this._currentElement)
        {
            this._currentElement.activate( true );

			if (this._currentElement.data.isText || this._currentElement.data.isPhoto)
				this._currentElement.activate( true ); // 2 times in order to switch on Edit Mode
        }
            
    }

	get currentArea()
	{
		return this.area;
	}

	get coverLabel()
	{
		return this.book.coverName;
	}
	

	getArea(id)
	{
		return this.area;
	}
	// --------------------------- RENDER --------------------------- //

	create()
	{
		super.create();

		this.frame = new shared.stage.Frame(this.data);
		this.frameAction = new shared.stage.FrameAction(this.data, { anchors : false, rotate : false});
		this.addChild(this.frame);
		this.addChild(this.frameAction);

		this.area = new shared.stage.BookArea(this.book.cover, this.data, this, "right", true);
		this.area.hideLabels = true;
		this.addChild(this.area, {height:this.book.coverHeight});
		
		this.buttonsContainer = new fx.components.HBox();
		this.leftArrow = new fx.components.IconButton({icon: fx.get("assets").previousIcon, className : "direction"});
		this.pageLabel = new fx.components.Text({className : "page-label"});
		this.rightArrow = new fx.components.IconButton({icon : fx.get("assets").nextIcon, className : "direction"});
		//this.leftArrow.visibleAtStart = false;
		this.buttonsContainer.addChild(this.leftArrow, {width:50, height:50});
		this.buttonsContainer.addChild(this.pageLabel, { width : 200, height : 30});
		this.buttonsContainer.addChild(this.rightArrow, {width:50, height:50});

		this.addChild(this.buttonsContainer, {width : 300, height:  50, left : "center", bottom : 0});

		this._mouse = new desktop.common.behaviour.Mouse(this);
		this._innerDragger = new desktop.common.behaviour.InnerDragger(this._mouse, this.data);
    }

	show(callback){
		
        super.show(callback);
        
        this.frame.hide();
        this.frameAction.hide();
	}

	onReady()
	{
		this.on("click", this.onPrevious, this.leftArrow);
		this.on("click", this.onNext, this.rightArrow);
		//this.on("click", this.onOptions, this.optionsButton);

		this.on("click", this.onAreaClick, this.area);

		this.on("click", this._onClick);
		
		this.on("select", this.onSelect, this._mouse);
		this.on("over", this.onOver, this._mouse);
		this.on("out", this.onOut, this._mouse);

		this._mouse.enable();
		this._innerDragger.enable();

		this.updatePage();
		
	}


	onOver(event)
    {
        this.frame.currentArea = event.area; 

        if (event.element != this.frame.currentElement)
		{
			if (event.element && (event.element.data.isText || event.element.data.isPhoto))
				this.frame.currentElement = event.element;
			else
				this.frame.currentElement = null;
		}
    }

	onOut(event)
    {
        this.frame.currentArea = null;
        this.frame.currentElement = null;
    }

	onSelect(event)
    {
		let element = event.detail ? event.detail.element : event.element;
		this.currentElement = element;

		if (this.area && event.originalEvent)
            this.area.selectActivePart(event.originalEvent);
    }


	_onClick(e)
    {
		if (this.area.data.isCover) return;

        let element = fx.dom.parent(e.target, ".BookArea");

		if (element) // sets active part
			this.area.selectActivePart(e);
		else
			this.area.activePart = "";
		
    }
	
	onDataEvent(event)
    {
        super.onDataEvent(event);
        
        switch(event.type)
        {
            case "cover-updated" :
				this.updateDisplay();
				break;
		}
	}

	

	updateDisplay()
	{
		super.updateDisplay();
		
		// resize area
		let percentage = this.book.shape_option == "landscape" ? 0.95 : 0.8,
			buttonsMinBottomMargin = 20,
			buttonsMinTopMargin = 30,
			width = this.realWidth,
			height = this.realHeight - this.buttonsContainer.realHeight + buttonsMinBottomMargin,
			screenWidth = width* percentage,
			screenHeight = Math.min(Math.max(0,height), height * percentage),
		 	ratio = this.book.coverHeight/this.book.coverWidth,// this.area.realHeight / this.area.realWidth,
			scale = (screenWidth * ratio < screenHeight) ? (screenWidth / this.book.coverWidth ) : (screenHeight / this.book.coverHeight),
		 	xPos = (width/scale - (this.area.realWidth )) / 2 , 
			yPos = (height/scale - (this.book.coverHeight )) / 2,
			left, top, bottom ;
		
		this.area.css({ "transform" : "scale(" + scale + ") translate(" + 0 + "px) translate(" + xPos + "px," + yPos + "px)" }); 

		bottom = Math.max(buttonsMinBottomMargin, this.realHeight - ((yPos*scale + this.book.coverHeight * scale) + buttonsMinTopMargin) - this.buttonsContainer.realHeight );
		left = Math.max(0, (width - this.buttonsContainer.realWidth) / 2);
		this.buttonsContainer.viewport({bottom : bottom, left : left});

		/*top = Math.max(0, (yPos*scale - this.optionsButton.realHeight) / 4);
		left = Math.max(0, (width - this.optionsButton.realWidth) / 2);

		this.optionsButton.viewport({top : top, left : left});
		
		this.optionsButton.label = this.coverLabel;

		this.optionsButton.show();*/
	}

	
	onAreaClick()
	{
		this.trigger("select");
		/*if (this.area.page.isCover)
			this.onOptions();
		else
			this.trigger("select");*/
	}

	onOptions()
	{
		this.trigger("options");
	}

	onPrevious()
	{	
		if (this._index > 0)
		{
			this._index--;
			this.updatePage();

			this.trigger("previous");
		}
	}

	onNext()
	{
		if (this._index <= this.book.elements.length)
		{
			this._index++;
			this.updatePage();

			this.trigger("next");
		}
	}

	firstPage()
	{
		this._index = 0;
		this.updatePage();
	}


	updatePage()
	{
		let page = (this._index == this.book.pages.length) ? this.book.cover : this.book.pages.getItemAt(this._index);
		this.area.displayedSide = page.isCover ? (this._index == 0 ? "right" : "left") : "";
		this.area.page = page;
		this.pageLabel.text = page.label();
		this.updateDisplay();

		this.leftArrow.enabled = this._index > 0;
		this.rightArrow.enabled = this._index < this.book.pages.length;

		if (page.isCover)
			this.area.activePart = "";
	}


	destroy()
	{
		super.destroy();

		this.frame.destroy();
		this.frameAction.destroy();

		this.area.destroy();
		
		this.leftArrow.destroy();
		this.pageLabel.destroy();
		this.rightArrow.destroy();

		this.buttonsContainer.destroy();
		//this.optionsButton.destroy();

		this._mouse.destroy();
		this._innerDragger.disable();
	}
});